import { render, staticRenderFns } from "./server.vue?vue&type=template&id=216ae792&scoped=true"
import script from "./server.vue?vue&type=script&lang=js"
export * from "./server.vue?vue&type=script&lang=js"
import style0 from "./server.vue?vue&type=style&index=0&id=216ae792&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216ae792",
  null
  
)

export default component.exports